export const websiteName = 'Expat Immo';
// export const apiGateway = `${
//   process.env.NODE_ENV === 'production' ? 'https' : 'http'
// }://expat-immo-prod.demoustier.net:1337`;
export const apiGateway = 'http://expat-immo-prod.demoustier.net:1337';
